import {PreferenceCardType} from "../Recoil State/Atoms/PageAtoms";

export const mothershipModel = (data:any) => {

    return {
        Name:data?.ModuleTypeName,
        ModuleTypeId:data?.ModuleTypeId,
        LicenseProfileName:data?.LicenseProfileName,
        LicenseProfileId:data?.LicenseProfileId,
    }
}

export const profileModel = (data:any) => {

    return {
        Name:data?.ModuleTypeName,
        ModuleTypeId: data?.ModuleTypeId,
        LicenseProfileName: data?.Name,
        LicenseProfileId:data?.Id,
    }
}

export const TerminalprofileModel = (data:any,RegisteredLicenseId:String,AppType:string,TerminalAppTypeName:string) => {

    return {
        Name:data?.ModuleTypeName,
        ModuleTypeId: data?.ModuleTypeId,
        LicenseProfileName: data?.Name,
        LicenseProfileId:data?.Id,
        RegisteredLicenseId:RegisteredLicenseId,
        AppType:AppType,
        TerminalAppTypeName:TerminalAppTypeName
    }
}

const checkModuleTypeNameExistsInProfileResponse = (moduleTypeName:string,profileDetailsResponse) : boolean => {
    return profileDetailsResponse?.some(module=>module.ModuleTypeName===moduleTypeName);
}

const checkModuleTypesExistsInProfileResponse = ( moduleTypeNames : Array<string> , profileDetailsResponse ) : boolean => {
    let modulesAvailableInProfile = false;
    for(let moduleTypeName of moduleTypeNames){
        modulesAvailableInProfile = checkModuleTypeNameExistsInProfileResponse(moduleTypeName,profileDetailsResponse);
        if(!modulesAvailableInProfile)break;
    }
        
    return modulesAvailableInProfile

}

export const modifyPreferenceCardInfo = (preferenceCardInfo:Array<PreferenceCardType>, profileDetailsResponse) : Array<PreferenceCardType> =>{
    let modifiedPreferenceCardInfo = JSON.parse(JSON.stringify(preferenceCardInfo));
    modifiedPreferenceCardInfo.forEach((modifiedPreferenceCard: PreferenceCardType)=>{
        modifiedPreferenceCard.shouldDisplay = (modifiedPreferenceCard.moduleTypeNames[0] !== "Interface ServerIS") ? checkModuleTypesExistsInProfileResponse(modifiedPreferenceCard.moduleTypeNames,profileDetailsResponse) : modifiedPreferenceCard.shouldDisplay;
    })
    return modifiedPreferenceCardInfo;
}
